module.exports = __webpack_public_path__ + "img/preview-front-protection.f07fcad4.png";